/**
 * Submission window configuration constants.
 *
 * The window defines the period during which submissions are accepted.
 * All times are interpreted in the configured timezone.
 *
 * To update the window, change the month/day/time values below.
 * To make the timezone dynamic in the future, pull TIMEZONE_ID from
 * an environment variable or API response instead of this constant.
 */

export const SUBMISSION_WINDOW = {
  START_MONTH: 4, // April (1-indexed)
  START_DAY: 1,
  END_MONTH: 5, // May
  END_DAY: 1,
  END_HOUR: 23,
  END_MINUTE: 59,
  TIMEZONE_ID: 'America/Los_Angeles',
} as const;
